import axios from "axios";

const BaseService = axios.create({
  baseURL: "https://clients.wearegenial.com/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

export default BaseService;

